import { Box, SxProps } from '@mui/material'
import { useDrawerPortalContext } from './DrawerPortalProvider'

export default function DrawerPortal({
  anchor = 'left',
  additionalId,
  sx,
}: {
  anchor?: 'left' | 'right'
  additionalId?: string
  sx?: SxProps
}) {
  const { setPortalNode, setSecondPortalNode } = useDrawerPortalContext()
  return (
    <Box
      ref={anchor === 'left' ? setPortalNode : setSecondPortalNode}
      data-portal-id={`drawers-${anchor}${
        additionalId ? `-${additionalId}` : ''
      }`}
      sx={{ flexShrink: 0, position: 'relative', ...sx }}
    />
  )
}
